module.exports = __webpack_public_path__ + "media/dorobek/assets/images/polon_logo-634caf5222b539105e47a0daf1178703.png";